<script setup lang="ts">
import type { CarouselMobileCard } from '~/types/benchmark-app.type'
import AllPricesSubscriptionHero from '@/components/all-prices/AllPricesSubscriptionHero.vue'
import FeaturedMobileCarousel from '@/components/FeaturedMobileCarousel.vue'
import SubscriptionsAndAccessSection from '~/components/benchmark-app/SubscriptionsAndAccessSection.vue'
import AllPricesPriceToolkit from '@/components/all-prices/AllPricesPriceToolkit.vue'

const bespokeData = {
  title: 'Bespoke Chart Creation',
  description:
    'Tailor and adjust charts to fit your specific needs. Ensure visibility into the exact data points crucial for your analysis',
}

const allEncompassingData = {
  title: 'All-Encompassing Price Data',
  description:
    'All Prices brings the full breadth of our price datasets together in one dashboard, to seamlessly switch between grades.',
}

const exportData = {
  title: 'Export & Analyse',
  description:
    'Export your customised charts and integrate data into your own workflow. API access is available on an enterprise-wide basis',
}

const phoneCards: CarouselMobileCard[] = [
  {
    ...bespokeData,
    src: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,h_1800,q_auto/v1733237639/assets/all-prices-subscription/Mask_group_gp9p3a.png',
  },
  {
    ...allEncompassingData,
    src: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,h_1800,q_auto/v1733237634/assets/all-prices-subscription/Section_pmqbkh.png',
  },
  {
    ...exportData,
    src: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,h_1800,q_auto/v1733237629/assets/all-prices-subscription/export_avthsw.png',
  },
]

const desktopCards: CarouselMobileCard[] = [
  {
    ...bespokeData,
    src: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,h_1800,q_auto/v1733241261/assets/all-prices-subscription/bespoke_desktop_kq3qga.png',
  },
  {
    ...allEncompassingData,
    src: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,h_1800,q_auto/v1733241258/assets/all-prices-subscription/all_desktop_udcllf.png',
  },
  {
    ...exportData,
    src: 'https://res.cloudinary.com/benchmarkminerals/image/upload/c_scale,f_auto,h_1800,q_auto/v1733241248/assets/all-prices-subscription/export_desktop_jtzyrk.png',
  },
]

const { $allPrices } = useNuxtApp()

const { data: summaries, refresh } = useAsyncData(async () => {
  const { summaries } = await $allPrices.getAllProductsSummary()
  return summaries
})

useAuthentication(() => refresh())
</script>

<template>
  <div>
    <AllPricesSubscriptionHero :summaries="summaries" />
    <div class="max-w-[90rem] mx-auto min-w-0 lg:px-12 2xl:px-0 lg:pb-10">
      <FeaturedMobileCarousel
        class="mt-11 mb-5"
        image-class="h-[332px] w-full"
        :phone-cards="phoneCards"
      />
      <SubscriptionsAndAccessSection
        class="hidden lg:block mt-16 2xl:!px-0"
        image-container-class="h-[579px] w-[490px]"
        content-container-class="xl:!pr-0"
        :phone-cards="desktopCards"
        title="All Prices. All in one place."
        show-contact-us-button
      />

      <AllPricesPriceToolkit class="hidden lg:flex mt-16" />
    </div>
  </div>
</template>
